export const EmbeddedIconStyles = {
  containerStart: 'absolute top-2/4 left-1 transform -translate-y-1/2',
  containerEnd: 'absolute top-2/4 right-1 transform -translate-y-1/2'
}
